import { useState, useRef, Fragment } from "react";
import Config from "../../Config";



import back from "../../back.png";
import InputParentsMulti from "../../helpers/InputParentsMulti";
import InputText from "../../helpers/InputText";
import InputTextArea from "../../helpers/InputTextArea";
import InputCombo from "../../helpers/InputCombo";
import InputDateTime from "../../helpers/InputDateTime";
 

function QueryNew(props)
{


       const [errTab, setErrTab] = useState([]);  //z info od serwera..

       const [emps, setEmps] = useState(null); //pracownicy..

       const [row, setRowX] = useState({
            pytanie:  "",        
            typ_ankiety: "yes_no",
            typ_pola_in: "text",
            wyswietlaj_do: '2025-12-12 12:00',
            pokaz_wynik_po_zaglosowaniu: '0',
            odbiorcy: [],
        });
        var tmpRow = row;


        const [checked, setChecked] = useState(false);
        const handleChange = () => {
            setChecked(!checked);
          };


        const valChecker = (fields) => {

            var allValid = true;
    
                  
            console.log(JSON.stringify(fields) );

            Object.entries(fields).forEach(function(entry) {
    
                var xKey    = entry[0];
                var xValue  = entry[1];                    

                var xValidName = xKey + "_valid";
    
                if(fields[xValidName] == false)
                {
                    allValid = false;
                    console.log("Error field: " + xKey);
                }
                
              });
            
              return allValid;
    
        }
    

        const valChangeListener = (filedName, val, correct, msg) => {         
            //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg); 
            var tabCheck = filedName.split('@');
            if(tabCheck.length == 2)
            {
                var tabName = tabCheck[0];
                var tabInx  = tabCheck[1];
                var tRef = row[tabName];
                if(correct)tRef[tabInx] = val;
                if(!correct)tRef[tabInx] = "";

                tmpRow[tabName] = tRef;     
                setRowX(  JSON.parse(JSON.stringify(tmpRow)) );  
    
                //setRowX( {...row, [tabName]:tRef } );   
                return;
            }
    
          
            tmpRow[filedName] = val;
            tmpRow[filedName+"_valid"] = correct;         
            setRowX(  JSON.parse(JSON.stringify(tmpRow)) );            
            //setRowX( {...row, [filedName]:val,  [filedName+"_valid"]:correct } );      
        }   
    
    
        const goNextNew = () => {
            console.log("goNext");
            saveData();
        }
    
        const saveData = () => {

            
        if(row.odbiorcy.length < 1)
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , "Wybierz odbiorców wiadomości"  ,  "ok"  ,null); 
                return;
            }

 

            if(!valChecker(row))
            {
                props.mainView.showDialog(props.userData.dic.dlg_notice_wrong , props.userData.dic.dlg_gocorrect  ,  "ok"  ,null); 
                return;
            }
        
    
            props.mainView.setProgress(-2);
    
            var req = row;
    
            fetch( Config.url + '/rest_v1_news,dodaj_ankiete', {
                method: 'POST', 
                body: JSON.stringify(req), 
                headers: {
                    'Content-Type': 'application/json',                    
                    'X-Api-Key': props.userData.apiKey,
                    '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                    '_p_dziecko_id_': props.userData.p_dziecko_id,
                    '_sec_key_': Config.genXKey() ,
                }
             })
             .then(res => res.json() )
             .then(res => {             
                        
                        props.mainView.setProgress(-1);
    
                        if(res._sys_ == undefined)
                        {
                            props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        }else
                        if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                        {
                           // props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                           setErrTab(res.result);
                        }else
                        if(res.status != undefined && res.status == "OK")
                        {
                            props.mainView.showDialog( "Sukces",  "Ankieta została dodana", "ok" , null);                        

                        

                            props.onBack(res.result);
                        }else
                        {
                            props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                        }
                       
             } )
             .catch(err => {   
                        props.mainView.setProgress(-1);       
                        props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
             });
                       
    
             return false;
    
        }



        const onParentsSelected = (tab) => {

           
                setRowX( {...row, ["odbiorcy"]:tab  } );
          }


        var itemsT = [
            { v: 'yes_no', title:'Pytanie Tak/Nie' },
            { v: 'v_text', title:'Odpowiedź do wpisania' },
        ];

        var itemsPole = [
            { v: 'text', title:'Tekst do wpisania' },
            { v: 'date', title:'Data' },
            { v: 'time', title:'Godzina' },
        ];

        var itemsWyniki = [
            { v: '0', title:'Nie pokazuj wyników głosowania' },
            { v: '1', title:'Pokaż wyniki głosowania innym uczestnikom' },
        ];

        return <div className="view_content">

                    <img src={back} onClick={props.onBack} className="back_img" title="wstecz"/>


                    <form className="eForm bg_center">


                                    <div className="form_tab">               
                                                <InputParentsMulti    userData={props.userData}  mainView={props.mainView}  onParentsSelected={onParentsSelected}   />  
                                    </div>

                                    <div className="form_split"></div>

                                    <div className="form_control">
                                                <div className="fieldName">Rodzaj pytania*</div>
                                                <InputCombo items={itemsT}  userData={props.userData} value={row.typ_ankiety} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_ankiety" placeholder={"Pytanie"} className='   ' req='1' firstUp="1" />
                                    </div>

                                    {
                                        row.typ_ankiety == "v_text" &&
                                        <Fragment>
                                                 <div className="form_control">
                                                     <div className="fieldName">Pole*</div>
                                                     <InputCombo items={itemsPole}  userData={props.userData} value={row.typ_pola_in} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="typ_pola_in" placeholder={"Pytanie"} className='   ' req='1' firstUp="1" />
                                                   </div> 
                                        </Fragment>
                                    }


                                    <div className="form_control">
                                                <div className="fieldName">Wyświetlaj*</div>
                                                <InputDateTime  userData={props.userData} value={row.wyswietlaj_do} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="wyswietlaj_do" placeholder={"Wyświetlaj do"} className=' w200   ' req='1' firstUp="1" />
                                    </div>

                                    <div className="form_control">
                                                <div className="fieldName">Wyniki*</div>
                                                <InputCombo items={itemsWyniki}  userData={props.userData} value={row.pokaz_wynik_po_zaglosowaniu} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pokaz_wynik_po_zaglosowaniu" placeholder={"Wyniki"} className='   ' req='1' firstUp="1" />
                                    </div>

                                    <div className="form_split"></div>
                                    
                                    <div className="form_control">
                                                <div className="fieldName">Pytanie*</div>
                                                <InputTextArea   userData={props.userData} value={row.pytanie} err={errTab}  valChange={valChangeListener} goNext={goNextNew} name="pytanie" placeholder={"Pytanie: "} className=' w400 h100 ' req='1' firstUp="1" />
                                    </div>



                                    <div className="form_split"></div>

                                    <div className="form_btn">
                                            <div className="btn" onClick={saveData}>dodaj</div>
                                            &nbsp;&nbsp;
                                            <div className="btn" onClick={props.onBack}    > anuluj</div>
                                    </div>

                                                                        


                    </form>
        </div>


}

export default QueryNew;